import Vue from 'vue';
import PreisschieneService from './preisschiene.service';
import * as _ from 'lodash';
import abstractStore from '../../store/abstractstore';

export const getDefaultSort = () => ({ currentSort: 'bezeichnung', currentSortDir: 'asc' });

const getDefaultItem = () => ({
    id: null,
    bezeichnung: null,
    aktiv: null,
});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
    selectedIncludeDeactivated: false,
    ...abstractStore.getAbstractValue(getDefaultSort().currentSort, getDefaultSort().currentSortDir),
});

const preisschiene = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        selectedIncludeDeactivated(state, data) {
            Vue.set(state, 'selectedIncludeDeactivated', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await PreisschieneService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await PreisschieneService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await PreisschieneService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { headers, data } = await PreisschieneService.query(params);

            let currPage = params && params.params && params.params.page ? params.params.page : 0;
            context.commit('updateCurrentPage', currPage);

            let size = params && params.params && params.params.size ? params.params.size : 20;
            let totalCount = headers['x-total-count'];
            let totalPages = 1;

            if (_.toNumber(totalCount) > 0 && _.toNumber(size) > 0) {
                totalPages = _.toNumber(totalCount) / _.toNumber(size);
            }

            context.commit('updateTotalPages', _.ceil(totalPages));

            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await PreisschieneService.delete(slug);
        },
        selectedIncludeDeactivated(context, data) {
            context.commit('selectedIncludeDeactivated', data);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
        selectedIncludeDeactivated(state) {
            return state.selectedIncludeDeactivated;
        },
    },
};

export default _.merge(preisschiene, abstractStore.getDefaultStore());
